import axios from 'axios';
import Cookies from 'js-cookie';

export interface WMSLayer {
  name: string;
  title: string;
}

export async function fetchWMSLayers(): Promise<WMSLayer[]> {
  let caseStudy = Cookies.get('caseStudy');

  if (!caseStudy) {
    return [];
  }

  if (caseStudy === 'pnr_narbonnaise') {
    caseStudy = 'france';
  }

  // Tell TypeScript it's now definitely a string
  const caseStudyPrefix = caseStudy;

  const res = await axios.get(
    'https://maps.plantnet.org/mapserver/hua?VERSION=1.3.0&request=GetCapabilities&service=WMS',
    { responseType: 'document' },
  );

  const xml = res.data as Document;
  const layers: WMSLayer[] = [];
  const layerNodes = xml.querySelectorAll('Layer > Layer');

  layerNodes.forEach((node: Element) => {
    const name = node.querySelector('Name')?.textContent;
    const title = node.querySelector('Title')?.textContent;
    if (name && title && name.startsWith(caseStudyPrefix)) {
      layers.push({ name, title });
    }
  });

  return layers;
}
